import { getAppConfig } from "./config";
import { getAppLinks } from "./links";
import { getAppRoutes } from "./router/routes";
import { createApiClient } from "./services/api/createApiClient";
import { createAppApiClient } from "./services/api/createAppApiClient";

const links = getAppLinks();
const routes = getAppRoutes(links);
const config = getAppConfig();

const apiClient = createApiClient({
  baseURL: config.apiBaseUrl,
});

const appApiClient = createAppApiClient(apiClient);

export const getAppContainer = () => ({
  config,
  routes,
  links,
  appApiClient,
});

export type AppContainer = ReturnType<typeof getAppContainer>;
